import * as React from 'react';
import SuccessAlert from './SuccessAlert';
import { Appointments, VendorsApi } from '@weddingspot/ws-api-client';
import { CheckoutVenueRecommendationsCardsList, CheckoutVenueRecommendationsCardInterface } from '@weddingspot/ws-core-components';
import { CheckoutContext, Steps } from '../utils/CheckoutContext';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';
import { format } from 'date-fns';
import AppLogger from '../../../utils/logging';
const logger = AppLogger.createLogger();

const styles = require('../CheckOutPage.module.scss');

const MoreVenues = () => {
    const {
        setConfirmButtonName,
        setConfirmButtonAction,
        setSecondaryButtonName,
        setSecondaryButtonAction,
        setStep,
        submittedInquiryData,
        setIsRequested,
        recommendationCards,
        setRecommendationCards,
        setHotelRecommendationCards,
        setHotelRecommendations,
        setMoreVenuesSanded,
        setIsConfirmDisabled,
    } = React.useContext(CheckoutContext);

    const changeIsChecked = React.useCallback(
        (id: number) => {
            setRecommendationCards(
                recommendationCards.map((item: CheckoutVenueRecommendationsCardInterface) => {
                    if (item.id === id) {
                        item.isChecked = !item.isChecked;
                    }
                    return item;
                })
            );
        },
        [recommendationCards]
    );

    const getHotelsRecommendationsStep = () => {
        const postHotelsData = {
            ws_seed_ids: recommendationCards.map((item) => Number(item.id)),
            limit: 6,
        };
        setIsRequested(true);
        VendorsApi.getHotelRecommendations(postHotelsData).then((hotels) => {
            setHotelRecommendationCards(
                hotels.map((item) => ({
                    title: item.name,
                    location: `${item.city}, ${item.state}`,
                    image: item.image,
                    isChecked: true,
                    checkedLabel: 'Send message',
                    id: item.csn_id,
                    type: item.type,
                }))
            );
            setHotelRecommendations(
                hotels.map((item) => ({
                    id: item.csn_id,
                    name: item.name,
                    location: `${item.city}, ${item.state}`,
                    imageUrl: item.image,
                    lastUpdated: new Date().getTime(),
                }))
            );
            setIsRequested(false);
            hotels.length ? setStep(Steps.HotelsRecommendations) : setStep(Steps.Final);
        });
    };

    React.useEffect(() => {
        const submittedCards = recommendationCards.filter((item: CheckoutVenueRecommendationsCardInterface) => item.isChecked);
        setConfirmButtonName(`Message ${submittedCards.length} venues`);
        if (submittedCards.length === 0) {
            setIsConfirmDisabled(true);
        }
        const submitData = {
            email: submittedInquiryData.email,
            first_name: submittedInquiryData.first_name,
            last_name: submittedInquiryData.last_name,
            phone_number: submittedInquiryData.phone_number,
            guest_count: submittedInquiryData.guest_count,
            preferred_date_1: submittedInquiryData.date,
            message: submittedInquiryData.message,
            contact_reason: null,
            outreach_type: Appointments.OutreachTypes.WEDDING_FLOW,
            tos_shown: false,
            vendor_ids: submittedCards.map((item: CheckoutVenueRecommendationsCardInterface) => Number(item.id)) || [],
            creation_source: 'shopping-cart' as const,
        };
        if (!submitData.preferred_date_1) {
            /* @ts-ignore */
            delete submitData.preferred_date_1;
        } else {
            submitData.preferred_date_1 = format(new Date(submitData.preferred_date_1), 'yyyy-MM-dd');
        }

        setConfirmButtonAction(() => {
            setIsRequested(true);
            VendorsApi.sendMassInquiries(submitData)
                .then(() => {
                    setIsRequested(false);
                    setMoreVenuesSanded(true);
                    getHotelsRecommendationsStep();
                })
                .catch((e) => {
                    setIsRequested(false);
                    logger.error(e);
                });
        });
    }, [recommendationCards, submittedInquiryData]);

    React.useEffect(() => {
        setSecondaryButtonName('Skip');
        setSecondaryButtonAction(() => {
            getHotelsRecommendationsStep();
        });
        logEvent(AnalyticsEvent.EVTNM_SHOWN_VENUE_RECOMMENDATIONS, {
            Source: 'Checkout page',
        });
        return () => {
            setIsConfirmDisabled(false);
        };
    }, []);

    return (
        <div className={styles.moreVenues}>
            <SuccessAlert />
            <h2>Send your message to these other great venues.</h2>
            <CheckoutVenueRecommendationsCardsList list={recommendationCards} changeIsChecked={changeIsChecked} />
        </div>
    );
};

export default MoreVenues;
